import React, { useState, useEffect } from 'react';
import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { title } from '../../constant/title';

HighchartsMore(Highcharts);

const PieChart = ({ data }) => {
  const [result, setResult] = useState([]);

  const color = [
    '#074c89',
    '#564887',
    '#b85382',
    '#f05377',
    '#f0a18c',
    '#7C7C16',
    '#052B05',
    '#4ec04e',
    '#d8d836',
    '#51d836',
    '#a6c34c',
    '#fec84c',
    '#f48847',
    '#eb4841',
    '#ff4e00',
    '#F2840A',
    '#DEC218',
    '#C3D120',
    '#81be2a',
  ];

  useEffect(() => {
    let other = 100.0;
    let res = data.result.map(({ name, data, percentage }, i) => {
      const value = parseFloat(percentage);
      other -= value;
      return {
        name: name,
        y: value,
        color: color[4 - i],
      };
    });
    let max = Math.max(data.result.map((e) => e.percentage));
    res.push({
      name: 'Mobil Lainnya',
      y: other,
      color: color[result.length % 5],
      visible: false,
    });

    setResult(res);
  }, []);

  const options = {
    chart: {
      type: 'pie',
      renderTo: 'chart1',
      height: 320,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: `Grafik ${title(data.metric)}`,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        return (
          `<span style="font-size:12px; font-weight: bold">${this.point.name}</span><br />` +
          `<span style="font-size:12px;">Unit Terjual : ${this.percentage.toFixed(2)}%</span>`
        );
      },
    },
    plotOptions: {
      pie: {
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
        },
      ],
    },
    series: [
      {
        name: 'Brands',
        data: [...result],
        size: '85%',
        innerSize: '0%',
      },
    ],
    legend: { enabled: true },
    credits: { enabled: false },
  };

  return (
    <div id="chart1">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PieChart;
